import { Text } from "@fluentui/react/lib/Text";
import { ThemeProvider } from "@fluentui/react/lib/Theme";

import { Clone } from "./Actions/Clone";
import { AddressValidation } from "./Actions/DataQuality/AddressValidation";
import { DuplicateCheck } from "./Actions/DataQuality/DuplicateCheck";
import { Delete } from "./Actions/Delete";
import { Edit } from "./Actions/Edit";
import { Export } from "./Actions/Export";
import { ManageIgnoredSourceData } from "./Actions/ManageIgnoredSourceData";
import { Staging } from "./Actions/Staging";
import { Details } from "./Details";
import { Footer } from "./Footer";
import { LoadingIndicator } from "./Generic/LoadingIndicator";
import { IWithTranslatorProps, WithTranslator } from "./Generic/Translator";
import { Header } from "./Header";
import { Overview } from "./Overview";
import { useApp } from "./UseApp";
import { useAppStyles } from "./UseAppStyles";
import { UserSettings } from "./UserSettings";

export const App = WithTranslator((props: IWithTranslatorProps): JSX.Element => {
  const { translator } = props;
  const style = useAppStyles();
  const { isAuthenticated, theme } = useApp();

  if (!isAuthenticated) {
    return (
      <Text className={style.noauth}>
        {translator.get(`auth.notauthenticated`, `User is not authenticated. Please login.`)}
      </Text>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <LoadingIndicator>
        <header className={style.header}>
          <Header />
        </header>
        <main className={style.main}>
          <Overview />
          <Details />
          <UserSettings />
          <AddressValidation />
          <DuplicateCheck />
          <Export />
          <Delete />
          <Clone />
          <Staging />
          <ManageIgnoredSourceData />
          <Edit />
        </main>
        <Footer />
      </LoadingIndicator>
    </ThemeProvider>
  );
});
